import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import EmailVerification from "./-components/EmailVerification";

export const Route = createFileRoute("/_unauthenticated/email-verification")({
  validateSearch: z.object({
    email: z.string().optional(),
  }),
  component: EmailVerification,
});
